import React, { useCallback, useEffect, useState } from "react";
import "./App.css";
import { App } from "visual-chat-builder";
import {
  COMETCHAT_CONSTANTS,
  IS_AGENT_MODE,
  IS_NO_CODE,
  AiAgents,
} from "./constants.ts";
import "../node_modules/visual-chat-builder/dist/index.css";
import "@cometchat/chat-uikit-react/css-variables.css";
import {
  createTemporaryBuilder,
  getTemporaryBuilder,
  updateTemporaryBuilder,
} from "./services/builders.ts";

function VcbPreviewApp() {
  const [authBuilderSetting, setAuthBuilderSetting] = useState();
  const builderId = localStorage.getItem("ccPreviewBuilderId") || "";

  // To create a temporary builder
  const handleCreateBuilder = useCallback(async () => {
    try {
      const result = await createTemporaryBuilder({
        templateId: "default",
      });
      console.log("Builder created:", result);
      setAuthBuilderSetting(result.data.settings);
      localStorage.setItem("ccPreviewBuilderId", result.data.builderId);
    } catch (error) {
      console.error("Create failed:", error);
    }
  }, []);

  // To fetch a temporary builder
  const handleGetBuilder = useCallback(async () => {
    if (!builderId) {
      handleCreateBuilder();
    } else {
      try {
        const result = await getTemporaryBuilder(builderId);
        setAuthBuilderSetting(result.data.settings);
      } catch (error: any) {
        if (error.code === "ERR_BAD_REQUEST") {
          localStorage.removeItem("ccPreviewBuilderId");
          handleCreateBuilder();
        }
      }
    }
  }, [builderId, handleCreateBuilder]);

  const updateBuilderSetting = (settings: any) => {
    try {
      updateTemporaryBuilder({ settings, builderId });
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  useEffect(() => {
    if(!IS_AGENT_MODE) {
      handleGetBuilder();
    }

  }, []);
   
  let vcbApp = <></>;
  if (IS_AGENT_MODE) {
    vcbApp = (
      <App
        isNoCode={IS_NO_CODE}
        isAgentMode={IS_AGENT_MODE}
        isPreviewScreen
        builderAppAndUser={COMETCHAT_CONSTANTS}
        aiAgents={AiAgents}
      />
    );
  } else if (authBuilderSetting || builderId) {
    vcbApp = (
      <App
        authBuilderSetting={authBuilderSetting as any}
        onValuesChanged={updateBuilderSetting}
        builderId={builderId}
        enableValuesChangedCallback
        isPreviewScreen
      />
    );
  }

  return (
    <div className='App' id='cb-preview-app'>
      {vcbApp}
    </div>
  );
}

export default VcbPreviewApp;
